<template>
    <div>
        <div ref="query">
            <div class="newadd pr marginTop30 marginBom30 fsize32 fcolor_white flex-yCenter" @click="goAddDetail">
                <span>提交申请</span>
                <img src="@/assets/images/index/addDetail.png" alt />
                <span class="fsize14 pa" style="left: 260px; top: 50px">点击进入</span>
            </div>
            <div class="record">
                <div class="marginBom30 categoryTitle2 flex-yCenter">
                    <div class="line"></div>
                    进修记录
                </div>
                <div class="filter">
                    <el-form inline>
                        <el-form-item label="申请时间：">
                            <el-date-picker
                                v-model="filterForm.date"
                                type="daterange"
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                @change="changeDate"
                            ></el-date-picker>
                        </el-form-item>
                        <el-form-item>
                            <el-select v-model="filterForm.trainType" clearable placeholder="请选择进修类型">
                                <el-option
                                    v-for="item in dict.type.train_type"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                        <el-button
                            class="fr blueBtn1"
                            type="primary"
                            style="width: 124px; height: 40px"
                            @click="getData"
                            >查询</el-button
                        >
                    </el-form>
                </div>
            </div>
        </div>
        <div style="color: #ff0000; font-size: 18px" class="marginBom24">审批意见和进修院区请右拉下方滚动条，院区由进修科室安排</div>
        <div class="content" style="min-height: 430px">
            <el-table
                v-loading="tableLoading"
                ref="table"
                :data="trainApplyList"
                :height="heights >= 390 ? heights : 390"
                style="width: 100%"
            >
                <el-table-column prop="type" label="进修类型" width="109" align="center">
                    <span slot-scope="scope">
                        {{ dict.type.train_type.filter((item) => item.value == scope.row.trainType)[0].label }}
                    </span>
                    <!-- <span slot-scope="scope">{{ scope.row.trainType }}</span> -->
                </el-table-column>
                <el-table-column prop="applyTime" label="进修申请时间" width="133" align="center"></el-table-column>
                <el-table-column prop="name" label="进修申请表" width="133" align="center">
                    <template slot-scope="scope">
                        <template v-if="scope.row.applyBasic.sealedFlag != 1">
                            <el-button
                                type="text"
                                @click="
                                    $router.push({
                                        path: `/add/addDetail?progress=3&active=5&applyId=${scope.row.applyId}&trainType=${scope.row.trainType}`
                                    })
                                "
                                >下载</el-button
                            >
                            <el-button
                                type="text"
                                @click="
                                    $router.push({
                                        path: `/add/addDetail?progress=3&active=5&applyId=${scope.row.applyId}&trainType=${scope.row.trainType}`,
                                    })
                                "
                                >上传</el-button
                            >
                        </template>
                        <el-button v-else type="text" @click="previewFile(scope.row.applyBasic.sealedApplyAtt)"
                            >预览</el-button
                        >
                    </template>
                </el-table-column>
                <el-table-column label="报到通知书" width="133" align="center">
                    <div slot-scope="scope" v-if="scope.row.noticeStatus == 1">
                        <el-button type="text" @click="previewFile(scope.row.noticeUrl)">查看</el-button>
                        <el-button
                            type="text"
                            @click="
                                downLoadFile(
                                    scope.row.noticeUrl,
                                    `${scope.row.applyBasic.userName}报到通知书（${
                                        dict.type.train_type.filter((item) => item.value == scope.row.trainType)[0]
                                            .label
                                    }）`
                                )
                            "
                            >下载</el-button
                        >
                    </div>
                    <span v-else>-</span>
                </el-table-column>
                <el-table-column prop="registrationDate" label="报到时间" width="109" align="center">
                    <span slot-scope="scope">{{ scope.row.registrationDate ? scope.row.registrationDate : '-' }}</span>
                </el-table-column>
                <el-table-column prop="name" width="365" align="center">
                    <template slot="header">
                        <div>
                            <div>报到材料</div>
                            <div>（请在接到通知后3天内完成报到材料上报）</div>
                        </div>
                    </template>
                    <el-table-column prop="name" width="260" align="center">
                        <span slot="header" class="required"
                            >单位介绍信（如贵单位有固定模式请按照贵单位介绍信，若无，则参考下面模板）</span
                        >
                        <template slot-scope="scope">
                            <div class="flex-xCenter" v-if="scope.row.applyBasic.sealedFlag == 1">
                                <el-button class="marginRt10" type="text" @click="downLoadFile(template.recommendation)"
                                    >下载模版</el-button
                                >
                                <FileUpload
                                    v-if="scope.row.reviewStatus != 1"
                                    :isShowTip="false"
                                    class
                                    @on-success="uploadFile"
                                    id="1"
                                    :fileType="['png', 'jpg', 'jpeg', 'pdf']"
                                >
                                    <template #content>
                                        <el-button
                                            type="text"
                                            @click="uploadObj = { type: 1, applyId: scope.row.applyId }"
                                            >上传</el-button
                                        >
                                    </template>
                                </FileUpload>
                                <el-button
                                    type="text"
                                    :class="scope.row.reviewStatus != 1 ? 'marginLt10' : ''"
                                    v-if="scope.row.applyBasic.recommendation"
                                    @click="previewFile(scope.row.applyBasic.recommendation)"
                                    >查看</el-button
                                >
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="name" width="260" align="center">
                        <span slot="header" class="required"
                            >健康证明（①上传本年度健康体检总结页；②参考下面模板 ①或②均可）</span
                        >
                        <template slot-scope="scope">
                            <div class="flex-xCenter" v-if="scope.row.applyBasic.sealedFlag == 1">
                                <el-button
                                    type="text"
                                    class="marginRt10"
                                    @click="downLoadFile(template.medicalCertificate)"
                                    >下载模版</el-button
                                >
                                <FileUpload
                                    v-if="scope.row.reviewStatus != 1"
                                    :isShowTip="false"
                                    class
                                    @on-success="uploadFile"
                                    id="1"
                                    :fileType="['png', 'jpg', 'jpeg', 'pdf']"
                                >
                                    <template #content>
                                        <el-button
                                            type="text"
                                            @click="uploadObj = { type: 2, applyId: scope.row.applyId }"
                                            >上传</el-button
                                        >
                                    </template>
                                </FileUpload>
                                <el-button
                                    v-if="scope.row.applyBasic.medicalCertificate"
                                    :class="scope.row.reviewStatus != 1 ? 'marginLt10' : ''"
                                    type="text"
                                    @click="previewFile(scope.row.applyBasic.medicalCertificate)"
                                    >查看</el-button
                                >
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="name" label="放射监测等其他资料" width="160" align="center">
                        <template slot-scope="scope">
                            <div class="flex-xCenter" v-if="scope.row.applyBasic.sealedFlag == 1">
                                <FileUpload
                                    v-if="scope.row.reviewStatus != 1"
                                    :isShowTip="false"
                                    class
                                    @on-success="uploadFile"
                                    id="1"
                                    :fileType="['png', 'jpg', 'jpeg', 'pdf']"
                                >
                                    <template #content>
                                        <el-button
                                            type="text"
                                            @click="uploadObj = { type: 3, applyId: scope.row.applyId }"
                                            >上传</el-button
                                        >
                                    </template>
                                </FileUpload>
                                <el-button
                                    v-if="scope.row.applyBasic.otherCertificates"
                                    :class="scope.row.reviewStatus != 1 ? 'marginLt10' : ''"
                                    type="text"
                                    @click="previewFile(scope.row.applyBasic.otherCertificates)"
                                    >查看</el-button
                                >
                            </div>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="进修费用" width="100" align="center">
                    <span slot-scope="scope">
                        {{ scope.row.applyBasic.trainCost ? scope.row.applyBasic.trainCost : '-' }}
                    </span>
                </el-table-column>
                <el-table-column prop="registrationDate" label="院内报到" width="109" align="center">
                    <span
                        slot-scope="scope"
                        class="pointer fcolor_green"
                        v-if="scope.row.registeringNumber && scope.row.registeringNumber != 0"
                        @click="
                            $router.push({
                                path: '/report/index',
                                query: { applyId: [scope.row.applyId] }
                            })
                        "
                        >{{ scope.row.registeredNumber }}/{{ scope.row.registeringNumber }}</span
                    >
                </el-table-column>
                <el-table-column prop="registrationDate" label="科室报到" width="109" align="center">
                    <el-table-column label="进修科室" width="109" align="center" class="pr">
                        <template slot-scope="scope">
                            <div class="myTable flex-column">
                                <div
                                    class="myTable-td"
                                    v-for="(item, index) in scope.row.registrationProcFlag == 0
                                        ? scope.row.applyDeptList
                                        : scope.row.trainList"
                                    :key="index"
                                >
                                    {{ item.deptName }}
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="进修时间" width="233" align="center">
                        <template slot-scope="scope">
                            <div class="myTable flex-column">
                                <div
                                    class="myTable-td"
                                    v-for="(item, index) in scope.row.registrationProcFlag == 0
                                        ? scope.row.applyDeptList
                                        : scope.row.trainList"
                                    :key="index"
                                >
                                    {{ item.beginDate }}~{{ item.endDate }}
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="所属院区" width="233" align="center">
                        <template slot-scope="scope">
                            <div class="myTable flex-column">
                                <div
                                    class="myTable-td"
                                    v-for="(item, index) in scope.row.registrationProcFlag == 0
                                        ? scope.row.applyDeptList
                                        : scope.row.trainList"
                                    :key="index"
                                >
                                    <div class="text-overflow" style="width: 100%" v-if="item.hospitalArea">
                                        <span v-for="(o, oIndex) in item.hospitalArea.split(';')" :key="oIndex">
                                            {{ oIndex != 0 ? '，' : ''
                                            }}{{
                                                dict.type.hospital_area.filter((item) => item.value == o).length != 0
                                                    ? dict.type.hospital_area.filter((item) => item.value == o)[0].label
                                                    : ''
                                            }}
                                        </span>
                                    </div>
                                    <div v-else>-</div>
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="住院总" width="100" align="center">
                        <template slot-scope="scope">
                            <div class="myTable flex-column">
                                <div
                                    class="myTable-td"
                                    v-for="(item, index) in scope.row.registrationProcFlag == 0
                                        ? scope.row.applyDeptList
                                        : scope.row.trainList"
                                    :key="index"
                                >
                                    {{ item.principal ? item.principal : '-' }}
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="带教老师" width="109" align="center">
                        <template slot-scope="scope">
                            <div class="myTable flex-column">
                                <div
                                    class="myTable-td"
                                    v-for="(item, index) in scope.row.registrationProcFlag == 0
                                        ? scope.row.applyDeptList
                                        : scope.row.trainList"
                                    :key="index"
                                >
                                    {{ scope.row.firstInConfirmFlag === 1 ? item.teacherName : '-' }}
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="registrationDate" label="进修过程" width="109" align="center">
                        <div slot-scope="scope">
                            <el-button
                                type="text"
                                v-if="scope.row.registrationStatus == 1"
                                @click="goProcess(scope.row)"
                                >查看</el-button
                            >
                            <span v-else>-</span>
                        </div>
                    </el-table-column>
                </el-table-column>
                <el-table-column prop="registrationDate" label="离院登记" width="109" align="center">
                    <span
                        slot-scope="scope"
                        class="pointer fcolor_green"
                        v-if="scope.row.leavingNumber && scope.row.leavingNumber != 0"
                        @click="
                            $router.push({
                                path: '/leave/index',
                                query: { query: { applyId: [scope.row.applyId] } }
                            })
                        "
                        >{{ scope.row.leavedNumber }}/{{ scope.row.leavingNumber }}</span
                    >
                </el-table-column>
                <el-table-column label="结业鉴定" width="109" align="center">
                    <div slot-scope="scope" v-if="scope.row.leaveProcFlag == 1">
                        <el-button
                            type="text"
                            v-if="scope.row.appraisalPerson"
                            @click="previewText('结业鉴定', scope.row.appraisalPerson)"
                            >查看</el-button
                        >
                        <el-button type="text" v-else @click="graduationAppraisal(scope.row)">填写</el-button>
                    </div>
                </el-table-column>
                <el-table-column label="医院鉴定" width="109" align="center">
                    <div slot-scope="scope" v-if="scope.row.leaveProcFlag == 1">
                        <el-button
                            type="text"
                            v-if="scope.row.appraisalHospital"
                            @click="previewText('医院鉴定', scope.row.appraisalHospital)"
                            >查看</el-button
                        >
                        <span v-else>-</span>
                    </div>
                </el-table-column>
                <el-table-column label="结业证书" width="109" align="center">
                    <div slot-scope="scope" v-if="scope.row.leaveStatus == 1">
                        <el-button type="text" @click="previewImageList(0, scope.row)">查看</el-button>
                        <el-button type="text" @click="previewImageList(1, scope.row)">下载</el-button>
                    </div>
                </el-table-column>
                <el-table-column prop="name" label="审核状态" width="109" align="center">
                    <template slot-scope="scope">
                        <div class="flex-center" v-if="scope.row.endedFlag == 1">
                            <div class="abnormalState flex-center">
                                <div class="content"></div>
                            </div>
                            <span>已结束</span>
                        </div>
                        <div class="flex-center" v-else-if="scope.row.revokeStatus == 1 && scope.row.revokeType">
                            <div class="abnormalState flex-center">
                                <div class="content"></div>
                            </div>
                            <span>已撤销</span>
                        </div>
                        <div class="flex-center" v-else-if="scope.row.leaveStatus == 1">
                            <div class="normalState flex-center">
                                <div class="content"></div>
                            </div>
                            <span>已离院</span>
                        </div>
                        <div class="flex-center" v-else-if="scope.row.archivesStatus == 1">
                            <div class="abnormalState flex-center">
                                <div class="content"></div>
                            </div>
                            <span>已退档</span>
                        </div>
                        <div class="flex-center" v-else-if="scope.row.applyBasic.sealedFlag == 0">
                            <div class="normalState flex-center">
                                <div class="content"></div>
                            </div>
                            <span>待提交</span>
                        </div>
                        <div
                            class="flex-center"
                            v-else-if="scope.row.applyBasic.sealedFlag == 1 && scope.row.applyStatus == 0"
                        >
                            <div class="normalState flex-center">
                                <div class="content"></div>
                            </div>
                            <span>申请中</span>
                        </div>
                        <div
                            class="flex-center"
                            v-else-if="scope.row.applyStatus == 2 && scope.row.registrationProcFlag == 0"
                        >
                            <div class="failState flex-center">
                                <div class="content"></div>
                            </div>
                            <span>申请未通过</span>
                        </div>
                        <div
                            class="flex-center"
                            v-else-if="scope.row.applyStatus == 1 && scope.row.registrationProcFlag == 0"
                        >
                            <div class="normalState flex-center">
                                <div class="content"></div>
                            </div>
                            <span>已录取</span>
                        </div>
                        <div
                            class="flex-center"
                            v-else-if="scope.row.registrationProcFlag == 1 && scope.row.registrationStatus == 0"
                        >
                            <div class="normalState flex-center">
                                <div class="content"></div>
                            </div>
                            <span>报到中</span>
                        </div>
                        <div
                            class="flex-center"
                            v-else-if="scope.row.registrationStatus == 1 && scope.row.leaveProcFlag == 0"
                        >
                            <div class="normalState flex-center">
                                <div class="content"></div>
                            </div>
                            <span>进修中</span>
                        </div>
                        <div class="flex-center" v-else-if="scope.row.leaveProcFlag == 1 && scope.row.leaveStatus == 0">
                            <div class="failState flex-center">
                                <div class="content"></div>
                            </div>
                            <span>离院中</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="审批意见（初审）" width="160" align="center" show-overflow-tooltip>
                    <span
                        slot-scope="scope"
                        v-if="scope.row.applyTaskList.length > 0"
                        :class="
                            scope.row.applyTaskList.filter((o) => o.taskKey == 'first_approval')[0].taskStatus == 1
                                ? 'fcolor_green'
                                : 'fcolor_red'
                        "
                        >{{ scope.row.applyTaskList.filter((o) => o.taskKey == 'first_approval')[0].comment }}</span
                    >
                </el-table-column>
                <el-table-column label="审批意见（复审）" width="170" align="center" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <div v-for="item in scope.row.applyDeptList">
                            <span v-if="item.approvalStatus != -1">{{ item.deptName }}：</span>
                            <span :class="item.approvalStatus == 1 ? 'fcolor_green' : 'fcolor_red'">
                                {{ item.approvalComment }}
                            </span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="审批意见（终审）" width="160" align="center" show-overflow-tooltip>
                    <span
                        slot-scope="scope"
                        v-if="scope.row.applyTaskList.length > 2"
                        :class="
                            scope.row.applyTaskList.filter((o) => o.taskKey == 'final_approval')[0].taskStatus == 1
                                ? 'fcolor_green'
                                : 'fcolor_red'
                        "
                        >{{ scope.row.applyTaskList.filter((o) => o.taskKey == 'final_approval')[0].comment }}</span
                    >
                </el-table-column>
                <el-table-column label="操作" width="150" align="center" fixed="right">
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            v-if="
                                scope.row.applyBasic.sealedFlag == 1 &&
                                scope.row.applyStatus != 2 &&
                                scope.row.endedFlag != 1
                            "
                            @click="showExceptionApproval(scope.row)"
                            >异常申请</el-button
                        >
                        <el-button
                            type="text"
                            v-if="scope.row.revokeStatus != 1 && scope.row.endedFlag != 1"
                            @click="showRevokeApplication(scope.row)"
                            >撤销申请</el-button
                        >
                        <el-button
                            type="text"
                            v-if="scope.row.applyBasic.sealedFlag != 1"
                            @click="removeApplyRecord(scope.row)"
                            >删除</el-button
                        >
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!-- 文字预览 -->
        <Modal
            :title="textObj.title"
            :showState="textObj.showState"
            :footer="{ slots: true }"
            @cancel="textObj.showState = false"
        >
            <template #content>
                <p>{{ textObj.content }}</p>
            </template>
        </Modal>
        <!-- 图片列表 -->
        <ImgListModal
            :title="imgListModalObj.title"
            :showState="imgListModalObj.showState"
            :imgList="imgListModalObj.list"
            @cancel="imgListModalObj.showState = false"
        ></ImgListModal>
        <Modal
            :title="exceptionApprovalObj.title"
            :showState="exceptionApprovalObj.showState"
            @cancel="exceptionApprovalCancel"
            @confirm="exceptionApprovalConfirm"
        >
            <template #content>
                <el-form
                    ref="exceptionApprovalForm"
                    :rules="exceptionApprovalObj.rules"
                    :model="exceptionApprovalObj.form"
                    label-width="100px"
                >
                    <el-form-item prop="content" label="申请内容：">
                        <el-input v-model="exceptionApprovalObj.form.content" type="textarea"></el-input>
                    </el-form-item>
                    <div class="fsize20 marginBom24">上传附件</div>
                    <div class="flex-wrap">
                        <img
                            v-for="(item, index) in exceptionApprovalObj.form.abnormalAttList"
                            :key="index"
                            :src="item.attUrl"
                            class="marginRt18 marginBom24"
                            alt
                            width="130px"
                            height="100px"
                        />
                        <FileUpload
                            :isShowTip="false"
                            class="avatar-uploader pr marginRt18"
                            @on-success="uploadSuccess"
                            :fileType="['png', 'jpg', 'jpeg']"
                        >
                            <template #content>
                                <i @click="uploadType = item.value" class="el-icon-plus avatar-uploader-icon"></i>
                            </template>
                        </FileUpload>
                    </div>
                </el-form>
            </template>
        </Modal>
        <Modal
            :title="revokeApplicationObj.title"
            :showState="revokeApplicationObj.showState"
            @cancel="revokeApplicationCancel"
            @confirm="revokeApplicationConfirm"
        >
            <template #content>
                <el-form
                    ref="revokeApplicationForm"
                    :rules="revokeApplicationObj.rules"
                    :model="revokeApplicationObj.form"
                    label-width="100px"
                >
                    <el-form-item prop="revokeType" label="撤销类型：">
                        <el-select
                            v-model="revokeApplicationObj.form.revokeType"
                            placeholder="请选择撤销类型"
                            style="width: 100%"
                        >
                            <el-option
                                v-for="item in revokeTypeList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item
                        prop="revokeReason"
                        label="撤销原因："
                        v-if="revokeApplicationObj.form.revokeType == 2"
                    >
                        <el-input v-model="revokeApplicationObj.form.revokeReason" type="textarea"></el-input>
                    </el-form-item>
                </el-form>
            </template>
        </Modal>
    </div>
</template>
<script>
import {
    trainApplySelectApplyList,
    trainApplyDelete,
    trainBasicUploadRecommendation,
    trainVasicUploadMedicalCertificate, //上传申请表
    trainApplyJustUpdateApply, //上传结业鉴定
    trainOtherCertificate, //上传其他
    trainAbnormal, //异常申请
    getConfigKey, //系统参数
    trainApplyRevokeApplication //撤销进修申请
} from '@/utils/api';
import { parseTime } from '@/utils/ruoyi';
import { downLoadFile } from '@/utils/myUtil';
import Modal from '@/views/components/modal.vue';
import ImgListModal from '@/views/components/imgListModal.vue';
import { trainCertRecordList } from '@/utils/api';
export default {
    dicts: ['train_type', 'revoke_type', 'hospital_area'],
    components: { Modal, ImgListModal },
    data() {
        return {
            heights: 0,
            filterForm: {
                date: [],
                params: {}
            },
            tableLoading: true,
            trainApplyList: [],
            previewImgObj: {
                url: '',
                show: false
            },
            fileList: [],
            uploadObj: {
                type: 1,
                applyId: ''
            },
            textObj: {
                title: '',
                showState: false,
                content: ''
            },
            imgListModalObj: {
                title: '',
                list: [],
                showState: false
            },
            exceptionApprovalObj: {
                title: '异常申请',
                showState: false,
                form: {
                    content: '',
                    applyId: '',
                    abnormalAttList: []
                },
                rules: {
                    content: [{ required: true, message: '申请内容是必填的', trigger: 'blur' }]
                }
            },
            revokeTypeList: [
                {
                    label: '申请信息有误，需重新提交申请',
                    value: 1
                },
                {
                    label: '因故无法继续进修学习',
                    value: 2
                }
            ],
            revokeApplicationObj: {
                title: '撤销申请',
                showState: false,
                form: {
                    applyId: '',
                    revokeType: '',
                    revokeReason: ''
                },
                rules: {
                    revokeType: {
                        required: true,
                        message: '撤销类型是必选的',
                        trigger: 'change'
                    },
                    revokeReason: {
                        required: true,
                        message: '撤销原因是必填的',
                        trigger: 'blur'
                    }
                }
            },
            // 模版
            template: {}
        };
    },
    created() {
        this.getData();
        // 单位介绍信模版
        getConfigKey('train.recommendation').then((res) => {
            if (res.code == 200) {
                this.template.recommendation = res.msg;
            }
        });
        // 健康证明模版
        getConfigKey('train.medicalCertificate').then((res) => {
            if (res.code == 200) {
                this.template.medicalCertificate = res.msg;
            }
        });
    },

    updated() {
        this.$nextTick(() => {
            // // 根据浏览器高度设置初始高度
            this.heights = window.innerHeight - this.$refs.query.offsetHeight - 250;
            this.$refs.table.doLayout();
            // // 监听浏览器高度变化，修改表格高度
            window.onresize = () => {
                this.heights = window.innerHeight - this.$refs.query.offsetHeight - 250;
                this.$refs.table.doLayout();
            };
        });
    },
    methods: {
        // 日期切换
        changeDate(list) {
            if (list == undefined) {
                delete this.filterForm.params.beginApplyTime;
                delete this.filterForm.params.endApplyTime;
            } else {
                this.filterForm.params.beginApplyTime = parseTime(list[0], '{y}-{m}-{d}');
                this.filterForm.params.endApplyTime = parseTime(list[1], '{y}-{m}-{d}');
            }
        },
        // 获取列表数据
        getData() {
            this.tableLoading = true;
            trainApplySelectApplyList(this.filterForm).then((res) => {
                if (res.code == 200) {
                    this.trainApplyList = res.data;
                }
                this.tableLoading = false;
            });
        },
        // 删除申请记录
        removeApplyRecord(obj) {
            let that = this;
            that.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                trainApplyDelete(obj.applyId).then((res) => {
                    if (res.code == 200) {
                        that.$message.success('删除成功');
                        that.getData();
                    }
                });
            });
        },
        // 预览
        previewFile(src) {
            window.open(src);
        },
        // 预览文字信息
        previewText(title, text) {
            this.textObj.title = title;
            this.textObj.content = text;
            this.textObj.showState = true;
        },
        // 证书图片列表
        previewImageList(type, obj, name) {
            // type 0查看 1 下载
            let imgList = [];
            trainCertRecordList({ applyId: obj.applyId }).then((res) => {
                if (res.code == 200) {
                    res.rows.forEach((item) => {
                        imgList.push(item.certUrl);
                    });
                    if (type == 0) {
                        this.imgListModalObj.title = '结业证书';
                        this.imgListModalObj.list = imgList;
                        this.imgListModalObj.showState = true;
                    } else {
                        imgList.forEach((item) => {
                            downLoadFile(item);
                        });
                    }
                }
            });
        },
        // 下载
        downLoadFile(src, fileName) {
            downLoadFile(src, fileName);
        },
        // 上传
        uploadFile(res) {
            let that = this;
            //uploadType 1单位介绍信 2健康证明
            if (this.uploadObj.type == 1) {
                trainBasicUploadRecommendation(this.uploadObj.applyId, {
                    recommendation: res.url
                }).then((res) => {
                    if (res.code == 200) {
                        that.$message.success('上传成功');
                    }
                    that.getData();
                });
            } else if (this.uploadObj.type == 2) {
                trainVasicUploadMedicalCertificate(this.uploadObj.applyId, {
                    medicalCertificate: res.url
                }).then((res) => {
                    if (res.code == 200) {
                        that.$message.success('上传成功');
                    }
                    that.getData();
                });
            } else {
                trainOtherCertificate(this.uploadObj.applyId, {
                    otherCertificates: res.url
                }).then((res) => {
                    if (res.code == 200) {
                        that.$message.success('上传成功');
                    }
                    that.getData();
                });
            }
        },
        // 去过程记录
        goProcess(obj) {
            this.$router.push({
                path: '/process/index',
                query: { date: [obj.applyTime, obj.applyTime] }
            });
        },
        // 填写结业鉴定
        graduationAppraisal(obj) {
            this.$confirm('', '结业鉴定', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                showInput: true,
                inputType: 'textarea'
            }).then((e) => {
                trainApplyJustUpdateApply({
                    appraisalPerson: e.value,
                    applyId: obj.applyId
                }).then((res) => {
                    if (res.code == 200) {
                        this.$message.success('鉴定成功');
                        this.getData();
                    }
                });
            });
        },
        // 上传图片成功
        uploadSuccess(res, file, fileList) {
            if (res.code == 200) {
                let obj = {
                    attName: res.originalFilename,
                    attUrl: res.url
                };
                this.exceptionApprovalObj.form.abnormalAttList.push(obj);
            }
        },
        // 显示异常申请
        showExceptionApproval(obj) {
            (this.exceptionApprovalObj.form.applyId = obj.applyId), (this.exceptionApprovalObj.showState = true);
        },
        // 异常申请确认
        exceptionApprovalConfirm() {
            this.$refs.exceptionApprovalForm.validate((vaild) => {
                if (vaild) {
                    trainAbnormal(this.exceptionApprovalObj.form).then((res) => {
                        if (res.code == 200) {
                            this.$message.success('申请成功');
                            this.exceptionApprovalCancel();
                        }
                    });
                }
            });
        },
        // 关闭异常申请
        exceptionApprovalCancel() {
            this.exceptionApprovalObj.showState = false;
            this.exceptionApprovalObj.applyId = '';
            this.exceptionApprovalObj.abnormalAttList = [];
            this.$refs.exceptionApprovalForm.resetFields();
        },
        // 去申请页
        goAddDetail() {
            this.$router.push('/add/addDetail');
        },
        // 显示撤销
        showRevokeApplication(obj) {
            (this.revokeApplicationObj.form.applyId = obj.applyId), (this.revokeApplicationObj.showState = true);
        },
        // 撤销确认
        revokeApplicationConfirm() {
            this.$refs.revokeApplicationForm.validate((valid) => {
                if (valid) {
                    trainApplyRevokeApplication(this.revokeApplicationObj.form).then((res) => {
                        if (res.code == 200) {
                            this.$message.success('撤销申请成功');
                            this.revokeApplicationCancel();
                            this.getData();
                        }
                    });
                }
            });
        },
        // 关闭撤销申请
        revokeApplicationCancel() {
            this.revokeApplicationObj.form = {};
            this.revokeApplicationObj.showState = false;
            this.$refs.revokeApplicationForm.resetFields();
        }
    }
};
</script>
<style lang="scss" scoped>
::v-deep .el-button--primary {
    padding: 0;
}

.myTable {
    justify-content: space-around;

    & > .myTable-td:not(:last-child) {
        border-bottom: 1px solid #ebeef5;
    }

    & > .myTable-td {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
}

::v-deep .el-table .el-table__cell {
    padding: 0 !important;
}

::v-deep .el-table .cell {
    // padding: 0 !important;
    line-height: 50px !important;
}

.newadd {
    background: url('@/assets/images/index/shenqingBlue.png') no-repeat;
    width: 1200px;
    height: 120px;
    background-size: 100% 100%;
    padding: 38px 34px;
    box-sizing: border-box;

    span {
        padding-right: 42px;
    }

    &:hover {
        cursor: pointer;
    }
}

::v-deep .record {
    .filter {
        background-color: #f3f3f3;
        height: 80px;
        padding: 20px;
    }

    .el-form-item__label {
        padding: 0;
        font-size: 16px;
    }
}

::v-deep.avatar-uploader {
    .el-upload:focus {
        color: #333333;
    }

    .el-upload {
        border: 1px solid #979797;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .el-upload:hover {
        border-color: #253d88;
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 130px;
        height: 100px;
        line-height: 100px;
        text-align: center;
    }
}

::v-deep .el-scrollbar__thumb {
    background-color: skyblue;
    background-image: -webkit-linear-gradient(
        45deg,
        rgba(255, 255, 255, 0.2) 25%,
        transparent 25%,
        transparent 50%,
        rgba(255, 255, 255, 0.2) 50%,
        rgba(255, 255, 255, 0.2) 75%,
        transparent 75%,
        transparent
    );
}

::v-deep .is-horizontal {
    width: 98%;
    background: #ededed;
    box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    height: 10px !important;
}
</style>
